import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import LoadingSpinner from "./componenets/ui/LoadingSpinner";
// Lazy loading components
const Pricing = React.lazy(() => import("./pages/Pricing/Pricing"));
const Home = React.lazy(() => import("./pages/Home/HomePage"));
const Integrations = React.lazy(() => import("./pages/integrations/Integrations"));
const SyncModules = React.lazy(() => import( "./pages/syncmodules/SyncModules"));
const Hosting = React.lazy(() => import( "./pages/hosting/Hosting"));
const Persistence = React.lazy(() => import( "./pages/persistence/persistence"));
const MultiplayerKit = React.lazy(() => import("./pages/MultiplayerKit/Multipleplayerkit"));
const Discord = React.lazy(() => import("./pages/discord/discord"));
const RessourcesPage = React.lazy(() => import("./pages/Ressources/RessourcesPage"));
import AppLayout from "./componenets/ui/AppLayout";
import NotFoundPage from "./pages/NotFound/NotFoundPage";


const App = () => {
  return (
    <Router>
      <Suspense  fallback={<LoadingSpinner/>}>
        <Routes>
          <Route path="/" element={<AppLayout/>}>
            <Route index path="/" element={<Home/>} />
            <Route path="pricing" element={<Pricing/>} />
            <Route path="resources" element={<RessourcesPage/>} />
            <Route path="multiplayer" element={<MultiplayerKit/>} />
            <Route path="persistence" element={<Persistence/>} />
            <Route path="discord" element={<Discord/>} />
            <Route path="modules" element={<SyncModules/>} />
            <Route path="integration" element={<Integrations/>} />
            <Route path="hosting" element={<Hosting/>} />
            <Route path="*" element={<NotFoundPage />} />

          </Route>
        </Routes>
      </Suspense>
    </Router>
  )
}

export default App;
